import { forgotPasswordTheme } from './ForgotPassword/theme';
import { signInTheme } from './SignIn/theme';

export const authenticationTheme = {
  container: {
    body: 'palette.surface.5',
    borderColor: 'palette.transparent',
    borderRadius: '10px',
    borderWidth: '0px',
    header: 'palette.surface.4',
  },
  forgotPassword: forgotPasswordTheme,
  signIn: signInTheme,
};
